import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'quotation', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
  { path: 'auth', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
  { path: 'quotation', loadChildren: () => import('./features/quotation/quotation.module').then(m => m.QuotationModule) },
  { path: 'policy', loadChildren: () => import('./features/policy/policy.module').then(m => m.PolicyModule)},
  { path: 'error', loadChildren: () => import('./pages//error/error.module').then(m => m.ErrorModule)},
  { path: '**', redirectTo: '' },  // Wildcard route for a 404 page (optional)

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
